"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dayjsImport = require("dayjs");
var isBetween = require("dayjs/plugin/isBetween");
var advancedFormat = require("dayjs/plugin/advancedFormat");
var localizedFormat = require("dayjs/plugin/localizedFormat");
var timezone = require("dayjs/plugin/timezone");
dayjsImport.extend(isBetween);
dayjsImport.extend(advancedFormat);
dayjsImport.extend(localizedFormat);
dayjsImport.extend(timezone);
exports.dayjs = dayjsImport;
//# sourceMappingURL=dayjs.js.map